import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoginForm from "../../../components/login/LoginForm";
import Loading from "../../../components/common/Loading";
import { logo } from "../../../assets";
import { useSelector } from "react-redux";
import {
  getAccessToken,
  getError,
  getStatus,
  removeLoginMessage,
} from "../../../redux/slice/userSlice";
import AlertBox from "../../../components/common/AlertBox";
import { FaAngleLeft } from "react-icons/fa";

const AdminLogin = () => {
  const navigate = useNavigate();

  const status = useSelector(getStatus);
  const error = useSelector(getError);
  const token = useSelector(getAccessToken);

  useEffect(() => {
    if (status === "success" || token) {
      navigate("/admin/home", { replace: true });
    }
  }, [navigate, token, status]);

  return (
    <div className="flex justify-center items-center bg-adminPrimary sm:p-6 p-2 min-h-[100vh]">
      {/* Right Section */}
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? (
        <AlertBox
          type={status}
          message={error}
          toDispatch={removeLoginMessage}
        />
      ) : null}

      <section className="flex-none flex flex-col md:py-8 py-5 bg-primary rounded-md shadow-md">
        <div className="flex justify-between sm:px-[8.5vh] px-2">
          <Link
            className="flex justify-center items-center max-w-[100px]"
            to="/login"
          >
            <FaAngleLeft className="text-secondary" />
            <span className="text-secondary font-semibold pl-1">Back</span>
          </Link>
          <img
            src={logo}
            className="md:hidden block w-[124px] h-[48px]"
            alt="logo"
          />
        </div>
        <div className="sm:px-[180px] sm:py-[6vh] px-6 py-10">
          <div className="flex flex-col sm:w-[425px] w-[270px]">
            <h1 className="text-secondary font-bold font-poppins sm:text-[30px] text-[26px] leading-[45px]">
              ADMIN LOGIN
            </h1>
            <p className="text-black text-[16px] mb-[50px]">
              This login is only for Admin
            </p>
            <LoginForm />
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminLogin;
